<template>
  <div class="Warp">
    <van-notice-bar color="#1989fa" background="#ecf9ff">
      员工详情
    </van-notice-bar>
    <van-cell-group>
      <van-cell title="员工名称" :value="detail.name" />
      <van-cell title="员工电话" :value="detail.tel" />
      <van-cell title="员工昵称" :value="detail.nickname" />
      <van-cell>
        <template #title>
          <span class="custom-title">员工头像</span>
          <van-image
            width="2rem"
            height="2rem"
            :src="$store.state.imgUrl+detail.avatar"
            style="float:right"
            @click="clickImg"
          />
        </template>
      </van-cell>
      <van-cell title="个人简介" :label="detail.detail" />
      <van-cell title="是否企业管理员" :value="detail.is_company_manager==1?'是':'否'" />
      <van-cell title="申请企业员工状态" :value="detail.apply_company_status==1?'已开通':'审核中'" />
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      console.log(111);
      this.detail = this.$route.query;
      console.log(this.detail);
    },
    clickImg(e){
        console.log(e);
    }
  },
};
</script>
<style lang="less" scoped>
 .custom-title {
    // margin-right: 10px;
    vertical-align: top;
  }
</style>